import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=7dfd27a7"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"
import style0 from "./Colors.vue?vue&type=style&index=0&id=7dfd27a7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports